<template>
  <div>
    <div class="title">查询优惠券活动</div>
    <el-form class="queryForm" ref="form" label-width="80px">
      <el-form-item label="活动名称">
        <el-input v-model="name" placeholder="请填写活动名称"></el-input>
      </el-form-item>

      <el-form-item label="开始时间">
        <el-input v-model="beginTime" placeholder="请填写开始时间"></el-input>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-input v-model="endTime" placeholder="请填写结束时间"></el-input>
      </el-form-item>
    </el-form>

    <div class="button_container">
      <el-button class="queryButton" type="primary" @click="queryCouponActivity">检索</el-button>
    </div>

    <div class="flex-col coupon_list align-center">
      <div class="addActivity_container flex-row justify-start">
        <el-button class="addActivity" type="info" @click="addActivity">+ 新增活动</el-button>
      </div>
      <div class="coupon_item flex-col align-center" v-for="item of couponActivityList" :key="item.id">
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">活动id：</span>
          <span class="value">{{ item.activityId }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">活动名：</span>
          <span class="value">{{ item.activityName }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">开始时间：</span>
          <span class="value">{{ item.beginTime }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">结束时间：</span>
          <span class="value">{{ item.endTime }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">商户id：</span>
          <span class="value">{{ item.partnerId }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">商户名：</span>
          <span class="value">{{ item.partnerName }}</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-start">
          <span class="label">支持门店：</span>
          <div class="value flex-col align-end">
            <div v-for="pos of item.posList" :key="pos.id" style="margin-bottom: 10px">
              {{ pos.pos }}
            </div>
          </div>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">对应产品：</span>
          <span class="value">{{ item.productName }}({{ item.availableProductType }})</span>
        </div>
        <div class="coupon_item_row flex-row justify-between align-center">
          <span class="label">已发放数量：</span>
          <span class="value">{{ item.currentIssuedNum }}/{{ item.maxIssuanceNum }}</span>
        </div>
        <div class="coupon_button_group flex-row align-center justify-content-around">
          <el-button class="left" type="danger" @click="deletCouponActivity">删除</el-button>
          <button class="middle" @click="showQrcode(item)">{{ item.showQRCodeButton }}</button>
          <el-button class="right" type="primary" @click="editCouponActivity(item.activityId)">修改</el-button>
        </div>

        <div v-if="item.showQRCode" class="qrcode_container flex-row align-center justify-center">
          <img :src="item.qrcodeDataUrl" alt="">
        </div>
      </div>
      <div class="nullCouponActivity" v-if="couponActivityList.length === 0">
        暂无优惠券活动
      </div>
    </div>
  </div>
</template>

<script>
import {queryCouponActivityInfo} from "../../api/coupon";
import {findPartnerByPartnerId, getPosInfo, queryPosNameByPosId, queryProductList} from "../../graphql/api";
import {v4 as uuidv4} from 'uuid';
import {generateQrcode} from "../../api/axios/generate-qrcode";
import QRCode from "qrcode";
import logoUrl from "../../assets/the_logo.png";

export default {
  name: "coupon_activity_list",
  data() {
    return {
      name: "",
      beginTime: "",
      endTime: "",
      id: "",

      couponActivityList: []
    }
  },
  mounted() {
    this.queryCouponActivity();
  },
  methods: {
    generateQrcode,
    addActivity() {
      this.$router.push("/coupon_activity_mgr")
    },

    // 调用查询优惠券活动接口
    queryCouponActivity() {
      console.log('开始查询');
      queryCouponActivityInfo().then(res => {
        console.log('查询优惠券活动', res);
        if (res.data.queryAllCouponActivity) {
          this.couponActivityList = res.data.queryAllCouponActivity;
          this.handleDate(this.couponActivityList)
        }
      }).catch(error => {
        console.log('接口调用异常', error);
      })
    },

    handleDate(data) {
      for (const item of data) {
        // 增加展示二维码容器参数
        this.$set(item, 'showQRCode', false);
        this.$set(item, "showQRCodeButton", '展示二维码');
        this.$set(item, "qrcodeDataUrl", '');

        findPartnerByPartnerId(item.partnerId).then(res => {
          this.$set(item, "partnerName", res.data.findPartnerByPartnerId.name);
        }).catch(error => {
          console.log('查询商户号异常', error);
        })

        let posList = item.posIdListStr.split(",");
        let posNameList = []
        for (const pos of posList) {
          queryPosNameByPosId({
            posId: pos
          }).then(res => {
            if (res.data.findPosInfoByPosId) {
              posNameList.push(
                  {
                    id: uuidv4(),
                    pos: res.data.findPosInfoByPosId.pos.name
                  }
              )
            } else {
              console.log(`门店[${pos}]异常`);
            }

          }).catch(error => {
            console.log('查询门店异常', error);
          })
        }

        this.$set(item, "posList", posNameList);

        let productList = [];
        queryProductList({
          partnerId: item.partnerId
        }).then(res => {
          console.log('查询产品列表', res);
          let data1 = res.data.findGlobalProduct
          let data2 = res.data.queryProduct
          for (const pd of data1) {
            productList.push({
              productType: pd.productType,
              productName: pd.name
            })
          }

          if (data2) {
            for (const pd of data2) {
              productList.push({
                productType: pd.productType,
                productName: pd.name
              })
            }
          }

          for (const pd of productList) {
            if (pd.productType === item.availableProductType) {
              this.$set(item, "productName", pd.productName);
              break;
            }
          }
        }).catch(error => {
          console.log('查询产品列表异常', error);
        })
      }
    },

    deletCouponActivity() {
      this.$dialog({
        title: '提醒',
        message: '确认删除对应优惠券活动吗？',
        showCancelButton: true,
      }).then(res => {
        alert('此功能暂未上线！')
      }).catch(() => {

      })
    },

    editCouponActivity(couponActivityId) {
      this.$router.push({
        path: "/coupon_activity_mgr",
        query: {
          id: couponActivityId
        }
      })
    },

    // 展示二维码
    showQrcode(item) {
      item.showQRCode = !item.showQRCode;
      if (item.showQRCode) {
        item.showQRCodeButton = '隐藏二维码'
      } else {
        item.showQRCodeButton = '展示二维码'
      }

      // 获取当前项目域名url
      let url = window.location.href
      if (url.indexOf("testomc.nationaiot.com") !== -1) {
        url = "https://testzmcf.nationaiot.com"
      } else if (url.indexOf("omc.nationaiot.com") !== -1) {
        url = "https://zmxcl.nationaiot.com"
      }
      let content = `${url}/customer/wellcomeJump?state=51&couponActivityId=${item.activityId}`

      this.renderQrCode(content, item);
    },

    async renderQrCode(content, object) {
      const text = content; // 二维码内容
      console.log('二维码内容', text);
      const size = '200'; // 二维码大小
      const logoUrl = require('../../assets/the_logo.png'); // Logo图片路径
      let that = this;

      // 生成二维码的数据URL
      const qrcodeDataUrl = await new Promise((resolve, reject) => {
        QRCode.toDataURL(text, {type: 'image/png', width: size, height: size}, (err, url) => {
          if (err) {
            reject(err);
          } else {
            resolve(url);
          }
        });
      });

      // 加载Logo图片并绘制到Canvas上的二维码中间
      const img = new Image();
      img.src = logoUrl;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 设置Canvas大小与二维码相同
        canvas.width = size;
        canvas.height = size;

        // 设置背景颜色并填充Canvas
        const backgroundColor = '#FFFFFF'; // 这里设置您想要的背景颜色，例如白色
        ctx.fillStyle = backgroundColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // 绘制二维码到Canvas上
        const qrcodeImage = new Image();
        qrcodeImage.src = qrcodeDataUrl;
        qrcodeImage.onload = () => {
          ctx.drawImage(qrcodeImage, 0, 0, size, size);

          // 计算Logo的位置（居中）
          const logoSize = Math.min(size * 0.3, img.width, img.height); // Logo最大为二维码尺寸的30%
          const x = (size - logoSize) / 2;
          const y = (size - logoSize) / 2;

          // 绘制Logo到二维码中间
          ctx.drawImage(img, x, y, logoSize, logoSize);

          // 将Canvas转换为图片数据URL
          object.qrcodeDataUrl = canvas.toDataURL('image/png');
        };
      };
    }
  }
}
</script>

<style lang="scss" src="../../css/coupon_activity_list.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/coupon/coupon_activity_list.vue